var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBagLtr = function SvgBagLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.999 1.999C64.626 1.999 70 7.464 70 14.203v10.562h18.44a3.563 3.563 0 0 1 3.561 3.564v66.105A3.566 3.566 0 0 1 88.44 98H11.56A3.566 3.566 0 0 1 8 94.434V28.329a3.564 3.564 0 0 1 3.561-3.564H30V14.203C30 7.464 35.373 2 42 1.999zM13.22 92.77h73.56V29.996H70v12.918c0 1.453-1.161 2.633-2.59 2.633-1.43 0-2.588-1.18-2.588-2.633V29.996H35.175v12.918c0 1.453-1.159 2.633-2.588 2.633s-2.588-1.18-2.588-2.633V29.996H13.22zM41.998 7.263c-3.768 0-6.823 3.108-6.823 6.94v10.562h29.648V14.203c0-3.832-3.056-6.94-6.824-6.94z"
  })));
};
export default SvgBagLtr;